module.exports = __webpack_public_path__ + "static/img/Jake-Waterman.7170539.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jake-Waterman.jpg
// module id = i1HK
// module chunks = 0